import { useToast } from "vue-toastification";
import { i18n } from "@/libs/i18n";
import { jwtDecode } from 'jwt-decode'

const toast = useToast();

function showErrors(errors) {
  for (let i = 0; i < errors.length; i += 1) {
    toast.error(errors[i].toString())
  }
}

const baseInterceptor = instance => {
  instance.interceptors.request.use(config => {
    const currentUser = JSON.parse(sessionStorage.getItem('userData'))
    if (currentUser) {
      const token = currentUser?.id_token
      const decoded = jwtDecode(token)
      config.headers.Authorization = `Bearer ${currentUser.access_token}`
      config.headers['X-Tenant-Id'] = decoded?.tenant
    }

    return config
  })

  instance.interceptors.response.use(
    response => {
      if ((response.config.method === 'post' || response.config.method === 'put') && (response.status === 200 || response.status === 201) && !response.config.skipSuccessToast) {
        toast.success(response.data.message || 'Acción exitosa!')
      }
      return response
    },
    async error => {
      // El 401 lo maneja jwtService (refresh o logout).
      if (error?.response?.status === 401) {
        return Promise.reject(error);
      }

      // Manejo de errores 403, este error es diferente a nuestro estandar, debido a eso hay que hacer manejarlo de forma diferente con este condicional
      if(error.response.status === 403) {
        toast.error(i18n.global.t('errorMessages.403AccessNotAllowed'))
        return Promise.reject(new Error('Bad request'))
      }

      if (error.message === "Network Error") {
        toast.error(i18n.global.t("errorMessages.forbidden"));
      }

      if (error?.response?.data) {
        if (error.response.data.Message || error.response.data.message) {
          toast.error(
            error.response.data.Message || error.response.data.message
          );
        } else if (error.response.data.detail || error.response.data.title) {
          // Respuestas problem+json (.NET ProblemDetails, p. ej. notificator):
          // el mensaje viene en detail/title, no en Message/message.
          toast.error(error.response.data.detail || error.response.data.title);
        }
        if (error?.response?.data?.errors) {
          const errors = Object.values(error.response.data.errors);
          showErrors(errors);
        } else if (error.response.data.Errors) {
          const errors = Object.values(error.response.data.Errors);
          showErrors(errors);
        }
      }
      return Promise.reject(error)
    },
  )
}

export default baseInterceptor
